export default "__VITE_ASSET__DK9xuiUx__"